import React from "react";
import { Container, Grid } from "@material-ui/core";
import CardTeachers from "./CardTeachers";
import NewTeacher from "./NewTeacher";
import { useRole } from "../../hooks/useRole";

export default function Teachers() {
  const { isAdmin } = useRole();
  return (
    <Container maxWidth="lg">
      <Grid container spacing={1}>
        <Grid item sm={isAdmin ? 6 : 12} xs={12}>
          <CardTeachers />
        </Grid>
        {isAdmin && (
          <Grid item sm={6} xs={12}>
            <NewTeacher />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
